if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

          this.elements.viewer.addEventListener('click', (e) => {
          const video = e.target.closest('video');
          if (!video || !this.elements.viewer.contains(video)) return;

          // Prevent other handlers from interpreting the click (e.g., slide navigation)
          e.stopPropagation();

          if (video.paused) {
  video.muted = true;
  video.setAttribute('playsinline','');
  const p = video.play();
  if (p && p.catch) p.catch(() => {});

  // Add classes
  video.classList.add('video-playing');
  video.classList.remove('video-paused');
} else {
  video.pause();

  // Add classes
  video.classList.add('video-paused');
  video.classList.remove('video-playing');
}
        }, true)

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();

        // 👇 Preload all gallery images immediately (hidden or not)
        this.preloadImages();
      }

      /**
       * Preload all <img> inside the gallery (works even if slides are display:none).
       * Uses data-src/src and data-srcset/srcset + sizes so the browser chooses the right variant.
       */
      preloadImages() {
        const imgs = this.querySelectorAll('img');
        imgs.forEach((img) => {
          if (img.dataset.preloaded === 'true') return;

          // Prefer Shopify-deferred attributes, fall back to normal attributes
          const src    = img.getAttribute('data-src')    || img.getAttribute('src');
          const srcset = img.getAttribute('data-srcset') || img.getAttribute('srcset');
          const sizes  = img.getAttribute('sizes') || img.sizes || '100vw';

          // Nothing to preload
          if (!src && !srcset) return;

          const pre = new Image();

          // If responsive variants are available, set them so the browser picks the right one
          if (srcset) {
            pre.srcset = srcset;
            pre.sizes = sizes;
          }

          // Always set a concrete src as a fallback to guarantee a request
          if (src) pre.src = src;

          // Try to decode so it’s paint-ready once revealed
          if (pre.decode) pre.decode().catch(() => { /* noop */ });

          // Mark original <img> to avoid duplicate work
          img.dataset.preloaded = 'true';
        });
      }

      onSlideChanged(event) {
        if(event.detail.currentElement){
        console.log('onSlideChanged event: ', event);
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
            activeMedia.scrollIntoView({ behavior: 'smooth' });
          }
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) {
          //deferredMedia.loadContent(false);
          deferredMedia.querySelector('video').classList.add('video-playing');
          deferredMedia.querySelector('video').classList.remove('video-paused');
          deferredMedia.querySelector('video').play();
        }
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
